import React, { useState,useContext } from 'react';
import { Modal, Button, Form, Offcanvas, useBreakpoint } from 'react-bootstrap';
import { db } from '../FireBase'; // your firebase config file
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import '../css/Feedback.css'
import { getAuth } from 'firebase/auth';
import { AuthContext } from '../context/AuthContext'; // Import the AuthContext

const Feedback = ({show, onClose }) => {
     const { currentUser, logout } = useContext(AuthContext);
  const [feedback, setFeedback] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const auth = getAuth();
  // Detect if screen is small (mobile)
  const isMobile = window.innerWidth < 768; // or use a better hook

  const handleClose = () => {
 
    setFeedback('');
    setSuccessMsg('');
    setErrorMsg('');
    onClose();
  };
 

  const handleSubmit = async (e) => {
    e.preventDefault();
   

  if (!currentUser) {
    window.location.href = '/login'; // 👈 redirect if not logged in
    return;
  }
    if (!feedback.trim()) {
      setErrorMsg('Please enter your feedback.');
      return;
    }

    setLoading(true);
    setErrorMsg('');
    setSuccessMsg('');

    try {
      await addDoc(collection(db, 'form-data'), {
        userId: currentUser.cusmid,
        type:'feedback',
        feedback: feedback.trim(),
        createdAt: serverTimestamp(),
      });

      setSuccessMsg('Thank you for your feedback!');
      setFeedback('');
      onClose();
    } catch (error) {
      setErrorMsg('Failed to submit feedback: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Desktop modal
  const desktopModal = (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Feedback</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="feedbackTextarea" className="mb-3">
            <Form.Label>Your Feedback</Form.Label>
            <Form.Control
              as="textarea"
              rows={8}
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder="Write your feedback here..."
              required
              disabled={loading}
              style={{width:'100%'}}
            />
          </Form.Group>
          {errorMsg && <div className="text-danger mb-2">{errorMsg}</div>}
          {successMsg && <div className="text-success mb-2">{successMsg}</div>}
          <Button variant="outline-success" type="submit" disabled={loading} className="w-100 cus-feedback">
            {loading ? 'Submitting...' : 'Submit feedback'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );

  // Mobile offcanvas
  const mobileOffcanvas = (
    <Offcanvas className='feedback-mob' show={show} onHide={handleClose} placement="bottom" backdrop scroll >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Feedback</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="feedbackTextareaMobile" className="mb-3">
            <Form.Label>Your Feedback</Form.Label>
            <Form.Control
              as="textarea"
              rows={8}
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder="Write your feedback here..."
              required
              disabled={loading}
              style={{width:'100%'}}
            />
          </Form.Group>
          {errorMsg && <div className="text-danger mb-2">{errorMsg}</div>}
          {successMsg && <div className="text-success mb-2">{successMsg}</div>}
          <Button variant="outline-success" type="submit" disabled={loading} className="w-100 cus-feedback">
            {loading ? 'Submitting...' : 'Submit feedback'}
          </Button>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );

  return (
    <>
   

      {isMobile ? mobileOffcanvas : desktopModal}
    </>
  );
};

export default Feedback;
